import React from 'react';
import Grid from '@mui/material/Grid2';
import { Styles } from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import { useTranslation } from "react-i18next";
import MakeShop from "../../manage/shops/MakeShop";
import { connect } from "trim-redux";
import ShopHours from "../../manage/shops/components/ShopHours";
import ShopCategoryChooser from "../../manage/shops/components/ShopCategoryChooser";
import ShopMenus from "../../manage/shops/menus/ShopMenus";
import Title from "../../../components/elements/Title";
import { useNavigate, useLocation } from "react-router-dom";
import { Alert, IconButton, Tab, Tabs, Typography, useMediaQuery } from "@mui/material";
import { theme } from "../../../../config/design/theme";
import {CalendarClock, Grid2x2Check, MapPinned, Pen, ScrollText} from "lucide-react";
import ShopAddress from "../../manage/shops/components/ShopAddress";
import {fromApp} from "../../../../config/values";
import Button from "@mui/material/Button";

function MyShopDetails({ user , isApp}) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const hasShop = !!user?.shop?.id;

    // Determine tab value based on URL path
    const tabValue = location.pathname.split('/').pop();

    const handleTabChange = (event, newValue) => {
        navigate(`/panel/vendor/setting/${newValue}`);
    };

    const renderNeedShop = () => (
        <Alert
            severity="warning"
            action={
                <Button color="inherit" size="small" onClick={() => navigate('/panel/vendor/setting/details')}>
                    {t('editInfo')}
                </Button>
            }
        >
            {t('shopDetails')}
        </Alert>
    );

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('shopDetails')}>
            <Grid container spacing={2} justifyContent="center" className="shop-tabs">
                {(hasShop && !fromApp()) && (
                    <Grid size={12}>
                        <Tabs
                            style={{ marginBottom: 20 }}
                            value={tabValue}
                            onChange={handleTabChange}
                            textColor="primary"
                            variant={isMobile ? 'scrollable' : ""}
                            scrollButtons={isMobile ? 'auto' : ""}
                            aria-label="Tab"
                            centered={!isMobile}
                            className="tabs-v-container"
                        >
                            <Tab value="details" className="tab-stepper"
                                 label={
                                     <div className="custom_tabs">
                                         <IconButton className='custom_tabs_icon_button'>
                                             <Pen className="lucide-xl"/>
                                         </IconButton>
                                         <Typography component="span">{t('editInfo')}</Typography>
                                     </div>
                                 }
                            />
                            <Tab value="address" className="tab-stepper"
                                 label={
                                     <div className="custom_tabs">
                                         <IconButton className='custom_tabs_icon_button'>
                                             <MapPinned className="lucide-xl"/>
                                         </IconButton>
                                         <Typography component="span">{t('address')}</Typography>
                                     </div>
                                 }
                            />
                            <Tab value="categories" className="tab-stepper"
                                 label={
                                     <div className="custom_tabs">
                                         <IconButton className='custom_tabs_icon_button'>
                                             <Grid2x2Check className="lucide-xl"/>
                                         </IconButton>
                                         <Typography component="span">{t('categories')}</Typography>
                                     </div>
                                 }
                            />
                            <Tab value="menus" className="tab-stepper"
                                 label={
                                     <div className="custom_tabs">
                                         <IconButton className='custom_tabs_icon_button'>
                                             <ScrollText className="lucide-xl"/>
                                         </IconButton>
                                         <Typography component="span">{t('menus')}</Typography>
                                     </div>
                                 }
                            />
                            <Tab value="hours" className="tab-stepper"
                                 label={
                                     <div className="custom_tabs">
                                         <IconButton className='custom_tabs_icon_button'>
                                             <CalendarClock className="lucide-xl"/>
                                         </IconButton>
                                         <Typography component="span">{t('shopHours')}</Typography>
                                     </div>
                                 }
                            />
                        </Tabs>
                    </Grid>
                )}
                {tabValue === "details" && (
                    <Grid size={12}>
                        {
                            !isApp &&
                            <Title align="left" color="text" className='panel-title'>{t('shopDetails')}</Title>
                        }
                        <MakeShop create={!hasShop} />
                    </Grid>
                )}
                {tabValue === "address" && (
                    <Grid size={12}>
                        {hasShop ? <ShopAddress /> : renderNeedShop()}
                    </Grid>
                )}
                {tabValue === "categories" && (
                    <Grid size={12}>
                        {hasShop ? <ShopCategoryChooser /> : renderNeedShop()}
                    </Grid>
                )}
                {tabValue === "menus" && (
                    <Grid size={12}>
                        {hasShop ? <ShopMenus /> : renderNeedShop()}
                    </Grid>
                )}
                {tabValue === "hours" && (
                    <Grid size={12}>
                        {hasShop ? <ShopHours /> : renderNeedShop()}
                    </Grid>
                )}
            </Grid>
        </AppAnimate>
    );
}

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
    isApp: state.isApp,

});

export default withStyles(Styles)(connect(mstp)(MyShopDetails));
